'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'
import { EscrowFees } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

import { findThumbnail } from '../../../utils/photo'
import ServiceFeeIncludedTitle from '../../ServiceFeeIncludedTitle'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
}

const getItemPhotoThumbnail = (
  photos:
    | Array<{
        isMain: boolean
        thumbnails: Array<{ type: string; url: string }>
      }>
    | undefined,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ isMain }) => isMain)

  return findThumbnail(photo, size)
}

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
  escrowNoteTranslationKey?: string
}

const DetailedPriceBreakdown = ({
  bundleSummary,
  isSellerBusiness,
  selectedItems,
  escrowNoteTranslationKey,
}: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const firstItem = selectedItems[0]
  const isBundle = selectedItems.length > 1

  if (!firstItem) {
    return (
      <ServiceFeeIncludedTitle
        itemId={selectedItemIds[0]!}
        isSellerBusiness={isSellerBusiness}
        shouldTrimTitle
        shouldMinimiseTitle
        itemPrice={price}
        serviceFee={buyerProtectionFee}
        totalItemPrice={priceWithBuyerProtectionFee}
        isDisabled
      />
    )
  }

  return (
    <ServiceFeeIncludedTitle
      itemId={selectedItemIds[0]!}
      isSellerBusiness={isSellerBusiness}
      shouldTrimTitle
      shouldMinimiseTitle
      itemPrice={price}
      serviceFee={buyerProtectionFee}
      totalItemPrice={priceWithBuyerProtectionFee}
      detailedBreakdown={
        isBundle
          ? {
              itemTitle: firstItem.title,
              itemsCount: selectedItems.length,
              itemPhotoSrc: getItemPhotoThumbnail(firstItem.photos),
              // Passing data from bundle summary instead of fetching from escrow fees endpoint for now.
              // At the moment there is not support for multiple item id fetching for escrow fees
              escrowFees: {
                itemVerification: null,
                electronicsVerification: null,
                shipping: null,
                buyerProtection: {
                  discountPercentage: 0,
                  finalPrice: buyerProtectionFee,
                  discount: { amount: '0', currencyCode: buyerProtectionFee.amount },
                  type: EscrowFees.BuyerProtection,
                  isFree: Number(buyerProtectionFee.amount) === 0,
                  originalPrice: buyerProtectionFee,
                },
              },
            }
          : {
              itemTitle: firstItem.title,
              itemPhotoSrc: getItemPhotoThumbnail(firstItem.photos),
            }
      }
      escrowNoteTranslationKey={escrowNoteTranslationKey}
    />
  )
}

export default DetailedPriceBreakdown
